import * as React from "react";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Urls } from "../../../../../Urls";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { AdviceChargeReview } from "../../../Common/Review/Component/AdviceChargeReview";
import { DrawdownReview } from "../../../Common/Review/Component/DrawdownReview";
import { IncomePaymentReview } from "../../../Common/Review/Component/IncomePaymentReview";
import { InvestmentReview } from "../../../Common/Review/Component/InvestmentReview";
import { PaymentsInReview } from "../../../Common/Review/Component/PaymentsInReview";
import { WithDrawalReview } from "../../../Common/Review/Component/WithDrawalReview";
import { NewQuoteAction } from "../../Actions/NewQuoteAction";
import {
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { QuoteModel } from "../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { GiaContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContribution";
import { IsaContribution } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Isa/IsaContribution";

interface IStepReviewProps {
    data:  GiaContribution | PensionContribution | IsaContribution ;
    subAccountType: SubAccountType;
    model: QuoteModel;
}

export const StepReview = (props: IStepReviewProps) => {
    const { data, subAccountType, model } = props;

    const isWithDrawalShow = (): boolean => {
        switch (subAccountType) {
            case SubAccountType.StocksIsa:
                return model.SelectedProducts.find((ele) => SubAccountTypeHelper.isIsa(ele.SubAccountType))
                    ?.IsAddRegularWithdrawalSelected;
            case SubAccountType.InvestmentAccount:
                return model.SelectedProducts.find((ele) => SubAccountTypeHelper.isPP(ele.SubAccountType))
                    ?.IsAddRegularWithdrawalSelected;
            default:
                return false;
        }
    };
    const isIncomePaymentShow = (): boolean => {
        return (
            SubAccountTypeHelper.isOnPlatformPension(subAccountType) &&
            model.SelectedProducts.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.IsIncomePaymentDetailsSelected
        );
    };
    const isDrawDownShow = (): boolean => {
        return (
            SubAccountTypeHelper.isOnPlatformPension(subAccountType) &&
            model.SelectedProducts.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType != PensionType.None
        );
    };

    const isShowInvestmentSelection = (): boolean => {
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType))
            {return (
                (data as PensionContribution).PreRetirementInstrumentSelections?.Instruments?.length > 0 ||
                (data as PensionContribution).PostRetirementInstrumentSelections?.Instruments?.length > 0
            );}
        return data.InstrumentSelections?.Instruments?.length > 0;
    };

    const getReviewProps = () => {
        return { data: data, subAccountType: subAccountType, process: ProcessType.Quote, colNum: 3, extraInfo: model };
    };

    const getWithDrawalReviewProps = () => {
        return { data: data, subAccountType: subAccountType, process: ProcessType.Quote, colNum: 2, extraInfo: model };
    };

    const showAssetsToSell = () => {
        return showChooseAssetstoSell((data as PensionContribution)?.DrawdownModel, ChooseAssetsToSellFor.Drawdown);
    };

    const isImmediateTaxFreeLumpSum =
        model?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
            ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
    return (
        <>
            <PaymentsInReview {...getReviewProps()} />
            <AdviceChargeReview {...getReviewProps()} />
            {isShowInvestmentSelection() && (
                <InvestmentReview {...getReviewProps()} serviceProposition={model?.AccountServiceProposition} />
            )}
            {isWithDrawalShow() && <WithDrawalReview {...getWithDrawalReviewProps()} />}
            {isDrawDownShow() && (
                <DrawdownReview
                    {...getReviewProps()}
                    showDrawdownPriceLock={false}
                    showAssetsToSell={showAssetsToSell()}
                    modelData={model}
                    isImmediateLumpSum={false}
                    onEditAction={() =>
                        NewQuoteAction.copyQuoteInstruction(
                            subAccountType == SubAccountType.Npr
                                ? Urls.get().QuoteDrawdownDetailSIPP
                                : Urls.get().QuoteDrawdownDetailJSIPP
                        )
                    }
                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data)}
                />
            )}
            {isIncomePaymentShow() && (
                <IncomePaymentReview
                    {...getReviewProps()}
                    model={model}
                    onEditAction={() =>
                        NewQuoteAction.copyQuoteInstruction(
                            subAccountType == SubAccountType.Npr
                                ? Urls.get().QuoteIncomePaymentSIPP
                                : Urls.get().QuoteIncomePaymentJSIPP
                        )
                    }
                    isITFC={isImmediateTaxFreeLumpSum}
                />
            )}
        </>
    );
};
